"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _creatTemplates = _interopRequireDefault(require("./creatTemplates"));
var logistics = _interopRequireWildcard(require("@/api/logistics.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShippingTemplates',
  filters: {
    statusFilter: function statusFilter(status) {
      var statusMap = {
        0: '全国包邮',
        1: '部分包邮',
        2: '自定义'
      };
      return statusMap[status];
    },
    typeFilter: function typeFilter(status) {
      var statusMap = {
        0: '无',
        1: '按件数',
        2: '按重量',
        3: '按体积'
      };
      return statusMap[status];
    }
  },
  components: {
    CreatTemplates: _creatTemplates.default
  },
  data: function data() {
    return {
      isShow: false,
      dialogVisible: false,
      form: {
        keywords: ''
      },
      tableData: '',
      page: 1,
      limit: 20,
      loading: false
    };
  },
  created: function created() {
    this.getDataList();
  },
  methods: {
    // 添加
    handleSubmit: function handleSubmit() {
      this.$refs.addTemplates.dialogVisible = true;
      if (!sessionStorage.getItem('cityList')) this.$refs.addTemplates.getCityList();
      this.$refs.addTemplates.changType(0);
    },
    handleSearch: function handleSearch() {
      this.page = 1;
      this.getDataList();
    },
    // 分页
    pageChange: function pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.limit = e;
      this.getDataList();
    },
    // 数据列表
    getDataList: function getDataList() {
      var _this = this;
      this.loading = true;
      logistics.shippingTemplatesList({
        keywords: this.form.keywords,
        page: this.page,
        limit: this.limit
      }).then(function (res) {
        _this.loading = false;
        _this.tableData = res;
      });
    },
    // 编辑
    bindEdit: function bindEdit(item) {
      if (!sessionStorage.getItem('cityList')) this.$refs.addTemplates.getCityList();
      this.$refs.addTemplates.getInfo(item.id, item.appoint);
      this.$refs.addTemplates.changType(1);
    },
    // 删除
    bindDelete: function bindDelete(item) {
      var _this2 = this;
      this.$modalSure().then(function () {
        logistics.shippingDetete({
          id: item.id
        }).then(function (res) {
          _this2.$message.success('删除成功');
          _this2.getDataList();
        });
      });
      // logistics.shippingDetete()
    },
    getList: function getList() {
      this.getDataList();
    }
  }
};